import axios, { AxiosInstance, CancelTokenSource } from 'axios';
import ApiRequestParams from '../types/interfaces/api';
import ApiRequestType from '../types/enums/api';
import ApiUtils from '@shared/utils/api';

class ApiRequestManager {
  api: AxiosInstance;
  controller: CancelTokenSource;
  customHeaders: { header: string; value: string }[];
  constructor() {
    this.api = axios.create({ timeout: 100000 });
    this.controller = axios.CancelToken.source();
    this.customHeaders = [];
  }

  // Setters

  setCustomHeader(header: string, value: string) {
    this.customHeaders.push({ header, value });
  }

  // Request handler

  request(type: ApiRequestType, params: ApiRequestParams) {
    const { abort, data, endpoint, headers } = params;
    const url = ApiUtils.parseUrl({ endpoint });
    const config = ApiUtils.getConfig({
      abort,
      controller: this.controller,
      customHeaders: this.customHeaders,
      endpoint,
      headers,
    });

    switch (type) {
      case ApiRequestType.DELETE:
        return this.api.delete(url, config);
      case ApiRequestType.GET:
        return this.api.get(url, config);
      case ApiRequestType.POST:
        return this.api.post(url, data, config);
      case ApiRequestType.PUT:
        return this.api.put(url, data, config);
    }
  }

  // Request methods

  delete(params: ApiRequestParams) {
    return this.request(ApiRequestType.DELETE, params);
  }

  get(params: ApiRequestParams) {
    return this.request(ApiRequestType.GET, params);
  }

  post(params: ApiRequestParams) {
    return this.request(ApiRequestType.POST, params);
  }

  put(params: ApiRequestParams) {
    return this.request(ApiRequestType.PUT, params);
  }
}

const ApiRequestManagerInstance = new ApiRequestManager();
export default ApiRequestManagerInstance;
